module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/2@2x_a36790cbaac3c8539144ebddbf6f5ac5.png";